<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '场地询价')[0].value">
    <div style="margin-left: 3%;">
    <div v-if="siteShow" style="margin-top: 1%;height: 95%;">
      <el-form-item label="场地名称:"
                    style="margin-left: 70px;">
        <el-input v-model="search.name"
                  class="inputs"></el-input>
        <el-button style="margin-left: 20px;"
                  type="primary"
                  @click="Onsearch()">查询</el-button>
      </el-form-item>
      <div style="height: 80%; overflow: auto">
        <el-row v-loading="loding">
          <el-col v-for="(o, index) in ExhibitionVenueList "
                  :key="index"
                  :span="20"
                  :offset="2">
            <div class="flex-warp-item"
                @click="detail(o)">
              <div class="flex-warp-item-box">
                <div class="item-img">
                  <img :src="
                    Global.imgip +
                    o.imge
                  " />
                </div>
                <div class="item-txt">
                  <div class="item-txt-title">
                    <h3>{{ o.name }}</h3>
                  </div>
                  <div class="item-txt-other">
                    <div style="width: 100%">
                      <div class="item-txt-msg mb10">
                        <p style="padding-top: 10px;display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 1; overflow: hidden;">地址:{{o.areDesc}}</p>
                        <p style="padding-top: 5px;">面积:{{String(o.size).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}㎡</p>
                        <p style="padding-top: 5px;display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 3; overflow: hidden;">展位介绍:{{o.describe}}</p>
                      </div>
                      <div class="item-txt-msg item-txt-price">
                        <span class="font-price">
                          <span>价格￥</span>
                          <span style="font-size: 18px;">{{String(o.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-pagination @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search.currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="search.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    style="display: flex; justify-content: center;margin-top: 10px;">
      </el-pagination>
    </div>
    </div>
  </ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  data () {
    return {
      loding: false,
      caseID: localStorage.getItem("caseId"),

      total: 0,
      ExhibitionVenueList: [],
      detailview: false,
      SiteDetail: {},
      search:
      {
        currentPage: 1,
        pagesize: 10,
        name: "",
      },
      operates: 0,
      flowID: localStorage.getItem("flowID"),
      siteShow: true,
      childTitle: '',
      title: '场地询价'
    };
  },
  components: {
    ShowControl
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  created () {
    this.GetExhibitionVenueInfo();
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/ExhibitionServices")
    },
    handleSizeChange: function (size) {
      this.search.pagesize = size;
      this.GetExhibitionVenueInfo();
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.search.currentPage = currentPage;
      this.GetExhibitionVenueInfo();
    },
    Onsearch () {
      this.GetExhibitionVenueInfo();
    },
    GetExhibitionVenueInfo () {
      this.loding = true
      this.$http.post(`ExhibitionVenue/GetExhibitionVenueAsc`, this.search).then((res) => {
        if (res.success) {
          this.loding = false
          this.ExhibitionVenueList = res.dynamicObj
          this.total = res.totalRecord
          //let that = this;
          // let operate = that.$store.state.user.operate;
          // if (this.flowID == this.Global.FlowList.策划) {
          //   if ((that.$store.state.user.operate & (1 << 2)) == 0) {
          //     operate += 4;
          //     console.log(operate)
          //     that.operates = operate
          //     that.$store.commit("operatedepcomit", operate);
          //   }
          // }
        }
      })
    },
    detail (o) {
      this.$router.push({path:'SiteInquiryDetailCard',query:{ id : o.id }})
    },
  },
  // watch: {
  //   operates (newVal, oldVal) {
  //     if (newVal == 7) {
  //       if (this.flowID == this.Global.FlowList.策划) {
  //         this.$http.get(`User/OperateScore?round=${this.Round}`).then((res) => {
  //           if (res.success) {
  //             console.log(res.dynamicObj)
  //             let that = this;
  //             let operate = that.$store.state.user.operate;
  //             operate += 1;
  //             this.operates = operate;
  //             that.$store.commit("operatedepcomit", operate); 
  //           }
  //         })
  //       }
  //     } else {
  //       console.log(oldVal)
  //     }
  //   }
  // },
};
  </script>
  <style lang="less" scoped>
.flex-warp-item {
  padding: 5px;
  width: 100%;
  height: 190px;
  .flex-warp-item-box {
    border: 1px solid var(--next-border-color-light);
    width: 100%;
    height: 100%;
    border-radius: 2px;
    //display: inline-block;
    flex-direction: column;
    transition: all 0.3s ease;
    &:hover {
      cursor: pointer;
      border: 1px solid var(--el-color-primary);
      transition: all 0.3s ease;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
      .item-txt-title {
        color: var(--el-color-primary) !important;
        transition: all 0.3s ease;
      }
    }
    .item-img {
      width: 40%;
      height: 180px;
      padding: 5px;
      overflow: hidden;
      display: inline-block;
      img {
        transition: all 0.3s ease;
        width: 100%;
        height: 100%;
      }
    }
    .item-txt {
      width: 54%;
      height: 155px;
      flex: 1;
      padding: 15px;
      display: inline-block;
      flex-direction: column;
      overflow: hidden;
      .item-txt-title {
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        color: #666666;
        transition: all 0.3s ease;
        &:hover {
          color: var(--el-color-primary);
          text-decoration: underline;
          transition: all 0.3s ease;
        }
      }
      .item-txt-other {
        flex: 1;
        align-items: flex-end;
        display: flex;
        .item-txt-msg {
          font-size: 12px;
          color: #8d8d91;
        }
        .item-txt-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .font-price {
            color: red;
            .font {
              font-size: 22px;
            }
          }
        }
      }
    }
  }
}
.flex-warp-item1 {
  padding: 5px;
  width: 100%;
  height: 190px;
  .flex-warp-item-box1 {
    border: 1px solid var(--next-border-color-light);
    width: 100%;
    height: 100%;
    border-radius: 2px;
    //display: inline-block;
    flex-direction: column;
    transition: all 0.3s ease;
    .item-img1 {
      width: 40%;
      height: 180px;
      padding: 5px;
      overflow: hidden;
      display: inline-block;
      img {
        transition: all 0.3s ease;
        width: 100%;
        height: 100%;
      }
    }
    .item-txt1 {
      width: 54%;
      height: 155px;
      flex: 1;
      padding: 15px;
      display: inline-block;
      flex-direction: column;
      overflow: hidden;
      .item-txt-title1 {
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        color: #666666;
        transition: all 0.3s ease;
        // &:hover {
        //   color: var(--el-color-primary);
        //   text-decoration: underline;
        //   transition: all 0.3s ease;
        // }
      }
      .item-txt-other1 {
        flex: 1;
        align-items: flex-end;
        display: flex;
        .item-txt-msg1 {
          font-size: 12px;
          color: #8d8d91;
        }
        .item-txt-price1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .font-price {
            color: #42b8dd;
            .font {
              font-size: 22px;
            }
          }
        }
      }
    }
  }
}
</style>
  <style scoped>
.span {
  font-size: 24px;
  color: blue;
}

.indexItem {
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding-left: 70px;
}

.time {
  font-size: 12px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  padding: 0;
  min-height: auto;
}
.table {
  width: 100%;
}
.table > tr {
  width: 30%;
}
.table > tr > td {
  width: 30%;
}
.image {
  width: 100%;
  height: 100px;
  display: block;
}

.imgbox {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin: 0 auto;
}
.font {
  font-size: 1.1em;
  color: black;
}
.radius {
  margin: 1px 0;
  background-color: #00adef;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.inputs {
  width: 280px;
}
</style>